import {
    UPDATE_DEVICES,
    UPDATE_SERVICE_POINTS,
    UPDATE_READINGS,
    SERVICE_POINTS_LOAD_ERROR,
    SERVICE_POINTS_LOADING,
    SP_ALIAS_UPDATED,
    SP_ALIAS_UPDATE_ERROR,
    SP_ALIAS_UPDATE_STARTED,
    SP_CLEAR,
    FAILED_TO_LOAD_DEVICES, DEVICES_LOADING, FAILED_TO_LOAD_READINGS, READINGS_LOADING
} from "../action/spActions"

const initialState = {
    listLoaded: false
}

export const spReducer = function (state = initialState, action) {
    switch (action.type) {
        case UPDATE_SERVICE_POINTS: {
            const spList = action.spList.map(sp => ({
                    ...sp,
                    usageStartDateTime: undefined,
                    usageEndDateTime: undefined,
                    // ToDo: понять, зачем это нужно. Заменить на spdtlist
                    usageStart: Date.parse(sp.usageStartDateTime),
                    usageEnd: Date.parse(sp.usageEndDateTime)
                })
            );
            return {
                ...state,
                list: spList,
                listLoaded: true,
                loadError: false
            }
        }

        case UPDATE_DEVICES: {
            const servicePoints = state.list.slice()
            servicePoints
                .filter((sp) => sp.id === action.spId)
                .forEach((sp) => {
                    sp.devices = action.dvcList
                    sp.detailsLoadError = false
                    sp.detailsLoaded = true
                })

            return {
                ...state,
                list: servicePoints
            }
        }

        case DEVICES_LOADING: {
            const servicePoints = state.list.slice()
            servicePoints
                .filter((sp) => sp.id === action.spId)
                .forEach((sp) => {
                    sp.detailsLoaded = false
                    sp.detailsLoadError = false
                })

            return {
                ...state,
                list: servicePoints
            }
        }

        case FAILED_TO_LOAD_DEVICES: {
            const servicePoints = state.list.slice()
            servicePoints
                .filter((sp) => sp.id === action.spId)
                .forEach((sp) => {
                    sp.detailsLoaded = false
                    sp.detailsLoadError = true
                })

            return {
                ...state,
                list: servicePoints
            }
        }

        case READINGS_LOADING: {
            const servicePoints = state.list.slice()
            const sp = servicePoints.find((sp) => sp.id === action.spId)

            if (!sp) return state

            sp.readingsLoaded = false
            sp.failedToLoadReadings = false

            return {
                ...state,
                list: servicePoints
            }
        }

        case UPDATE_READINGS: {
            const servicePoints = state.list.slice()
            const sp = servicePoints.find((sp) => sp.id === action.spId)

            if (!sp) return state

            sp.readingsLoaded = true
            sp.failedToLoadReadings = false

            //const activeDevice = sp.devices.find(dvc => !dvc.removalDate)
            sp.devices.forEach(dvc => {
                dvc.configurationsList.forEach(cfg => {
                    action.rdgList.forEach(rdg => {
                        //activeDevice.measuringComponents.map(mc => console.log(mc.id))
                        const mc = cfg.mcList.find(mc => mc.id === rdg.id)
                        if (!!mc) {
                            mc.readings = rdg.readings
                            mc.serialNumber = dvc.serialNumber
                        }
                    })
                })

            })

            return {
                ...state,
                list: servicePoints
            }
        }

        case FAILED_TO_LOAD_READINGS: {
            const servicePoints = state.list.slice()
            const sp = servicePoints.find((sp) => sp.id === action.spId)

            if (!sp) return state

            sp.readingsLoaded = false
            sp.failedToLoadReadings = true

            return {
                ...state,
                list: servicePoints
            }
        }

        case SERVICE_POINTS_LOADING: {
            return {
                listLoaded: false,
                loadError: false
            }
        }

        case SERVICE_POINTS_LOAD_ERROR: {
            return {
                listLoaded: false,
                loadError: true
            }
        }

        case SP_ALIAS_UPDATE_STARTED: {
            return {
                ...state,
                spAliasUpdated: false,
                spAliasUpdateError: false
            }
        }

        case SP_ALIAS_UPDATED: {
            let list = state.list.slice()
            list.filter(sp => sp.id === action.spId)
                .forEach(sp => sp.alias = action.newAlias)

            return {
                ...state,
                list,
                spAliasUpdateError: false,
                spAliasUpdated: true
            }
        }

        case SP_ALIAS_UPDATE_ERROR: {
            return {
                ...state,
                spAliasUpdateError: true,
                spAliasUpdated: false
            }
        }

        case SP_CLEAR: {
            return initialState
        }

        default:
            return state
    }
}